// extracted by mini-css-extract-plugin
module.exports = {"main":"InternalSection-module--main--2BJhy","hero":"InternalSection-module--hero--1c94-","heroContent":"InternalSection-module--heroContent--29mlG"};